/**
 * frontend-log-api.js
 *  フロントエンドログ関連のAPI
 */
import session from '../session'

// プロトタイプ宣言追加メソッド
import '@/hrm-frontend/modules/functions/prototype-extends'

var uri = process.env.API_ENDPOINT

export default {
  /**
   * 管理画面用フロントエンドログ関連POSTリクエスト
   * @returns レスポンス
   */
  sendSystemLog (payload) {
    return session.post('{0}/api/hrm_apps/operation_monitoring/regist_frontend_system_log'.format(uri), payload)
  },
  /**
   * 求職者用フロントエンドログ関連POSTリクエスト
   * @returns レスポンス
   */
  sendSeekerLog (payload) {
    return session.post('{0}/api/hrm_apps/operation_monitoring/regist_frontend_seeker_log'.format(uri), payload)
  },
}



// WEBPACK FOOTER //
// ./src/api/frontend-log/frontend-log-api.js